import React, { useEffect, useState } from "react";
import styles from "./header.module.scss";
import cx from "classnames";

import { useDesktop } from "services/responsive";


export default function HeaderSection() {
  const [isActive, setActive] = useState(false);
  const desktop = useDesktop();

  //navbar scroll when active state
  const [navbarbg, setNavbar] = useState(false);
  const [menulink, menuLink] = useState(false);
  const [logo, setLogo] = useState(false);

  //navbar scroll changeBackground function
  const changeBackground = () => {
    if (window.scrollY <= 6600  ) {
      console.log(window.screenY);
      setNavbar(true);
      menuLink(true);
      setLogo(true);
    } else {
      setNavbar(false);
      menuLink(false);
      setLogo(false);
    }
  };

  useEffect(() => {
    changeBackground();
    window.addEventListener("scroll", changeBackground);
  });

  const toggleClass = () => {
    setActive(!isActive);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.paperflite_header}>
          <nav
            role="navigation"
            aria-labelledby="block-paperflite-main-menu-menu"
            id="block-paperflite-main-menu"
            className={cx(
              styles.block,
              styles.block_menu,
              styles.navigation,
              styles.menu_main
            )}
          >
            <h2 className={styles.visuallyhidden}>Main navigation</h2>
            <nav
              style={{ color: navbarbg }}
              className={cx(
                styles.navbar,
                styles.navbar_default,
                styles.navbar_fixed_top,
                styles.mega,
                styles.trans_helper,
                styles.navbar_small,
                { [styles.navbarTransparent]: navbarbg }
              )}
            >
              <div className={styles.container}>
                <div className={styles.navbar_header}>
                  <button
                    id="toggle-btn"
                    type="button"
                    className={styles.navbar_toggle}
                    data-toggle="collapse"
                    data-target="#navbar"
                    aria-expanded="false"
                    aria-controls="navbar"
                    onClick={toggleClass}
                  >
                    <span className={styles.sr_only}>Toggle navigation</span>
                    <span className={styles.icon_bar}></span>
                    <span className={styles.icon_bar}></span>
                    <span className={styles.icon_bar}></span>
                  </button>
                  <a
                    className={cx(styles.navbar_brand, styles.logo_text)}
                    href="https://www.paperflite.com/"
                  >
                    <span
                      id="navbarLogo"
                      className={cx(styles.navbar_logo_link, {
                        [styles.navbar_logo_white]: logo,
                      })}
                    ></span>
                  </a>
                </div>
                <div
                  id="navbar"
                  className={cx(styles.navbar_collapse, styles.collapse, {
                    [styles.show]: isActive,
                  })}
                >
                  <ul
                    className={cx(
                      styles.nav,
                      styles.navbar_nav,
                      styles.navbar_left
                    )}
                  >
                    <li
                      className={cx(
                        styles.dropdown,
                        styles.mega_fw,
                        styles.dropdown_container
                      )}
                      id="product"
                    >
                      <a
                        target="https://www.paperflite.com/product"
                        title="Product Page"
                        data-drupal-link-system-path="node/235"
                        data-toggle="dropdown"
                        data-hover="dropdown"
                        data-delay="350"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                        className={cx({ [styles.menuLink]: menulink })}
                      >
                        Product
                      </a>
                      <ul className={styles.dropdown_menu}>
                        <li>
                          <a href="https://www.paperflite.com/product">
                            PAPERFLITE
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/cleverstory">
                            CLEVERSTORY
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/heysales">
                            HEYSALES
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={cx(
                        styles.dropdown,
                        styles.mega_fw,
                        styles.dropdown_container
                      )}
                      id="features"
                    >
                      <a
                        target="_self"
                        className={cx(styles.dropdown_toggle, {
                          [styles.menuLink]: menulink,
                        })}
                        title="Features"
                        data-drupal-link-system-path="node/5"
                        data-toggle="dropdown"
                        data-hover="dropdown"
                        data-delay="350"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Features
                      </a>
                      <ul className={styles.dropdown_menu}>
                        <li>
                          <a href="https://www.paperflite.com/product/content-discovery">
                            Content Discovery
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/product/content-distribution">
                            Content Distribution
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/product/content-experience">
                            Content Experience
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/product/content-analytics">
                            Content Analytics
                          </a>
                        </li>
                        <li>
                          <a href="https://www.paperflite.com/product/content-intelligence">
                            Content Intelligence
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li className={cx(styles.dropdown, styles.mega_fw)}>
                      <a
                        className={cx({ [styles.menuLink]: menulink })}
                        href="https://www.paperflite.com/pricing"
                        data-drupal-link-system-path="node/9"
                      >
                        Pricing
                      </a>
                    </li>
                    <li className={cx(styles.dropdown, styles.mega_fw)}>
                      <a
                        className={cx({ [styles.menuLink]: menulink })}
                        href="https://www.paperflite.com/blogs"
                        target="_self"
                        data-drupal-link-system-path="blogs"
                      >
                        Blog
                      </a>
                    </li>
                    <li className={cx(styles.dropdown, styles.mega_fw)}>
                      <a
                        href="https://editor.cleverstory.io/"
                        target="_self"
                        className={cx(styles.btn_nav_right, {
                          [styles.menuLink]: menulink,
                        })}
                      >
                        Login
                      </a>
                    </li>
                    <li className={cx(styles.dropdown, styles.mega_fw)}>
                      <a
                        href="https://www.paperflite.com/signup"
                        target="_self"
                        className={cx(styles.btn_nav_right, {
                          [styles.menuLink]: menulink,
                        })}
                        title="Sign up for free"
                        data-drupal-link-system-path="node/205"
                      >
                        Sign up
                      </a>
                    </li>
                    <li className={cx(styles.dropdown, styles.mega_fw)}>
                      <a
                        href="https://www.paperflite.com/cleverstory/book-a-demo"
                        target="_self"
                        className={cx(
                          styles.btn_ghost,
                          styles.bookDemo,
                          styles.btn_nav_right
                        )}
                        data-drupal-link-system-path="node/259"
                      >
                        Request Demo
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </nav>
        </div>
      </div>
    </>
  );
}
